module.exports = __webpack_public_path__ + "img/headerlogo.7bb48876.png";